import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { WrappedFieldProps } from 'redux-form';
import { InputAdornment, TextField } from '@material-ui/core';

export interface InlineQuantityControlProps {
    name: string;
    value: number;
    onChange: (event: any) => void;
    //    Optional
    isDisabled?: boolean;
    adornmentText?: string;
    fullWidth?: boolean;
}

export type InlineQuantityControlFieldProps = InlineQuantityControlProps & WrappedFieldProps;

const useStyles = makeStyles(theme => ({
    input: {
        borderRadius: theme.spacing(0.5),
        borderWidth: 0,
        borderColor: 'transparent',
        width: theme.spacing(6),
        fontSize: 16,
        lineHeight: 1.5,
        color: '#243143',
        textAlign: 'right',
        marginTop: theme.spacing(1),
    },
    root: {
        minHeight: theme.spacing(6),
        paddingLeft: 16,
    },
}));

export const InlineQuantityControlField: FC<InlineQuantityControlFieldProps> = props => {
    const {
        fullWidth,
        isDisabled,
        adornmentText,
        input,
        meta: { touched, invalid, error },
    } = props;
    const classes = useStyles();
    return (
        <TextField
            type="number"
            style={fullWidth ? { width: '100%' } : null}
            disabled={isDisabled}
            InputProps={{
                disableUnderline: true,
                endAdornment: adornmentText && (
                    <InputAdornment position="start" className={classes.root}>
                        {adornmentText}
                    </InputAdornment>
                ),
            }}
            className={classes.input}
            error={touched && invalid}
            helperText={touched && error}
            {...input}
        />
    );
};

//
// export const InlineQuantityControlField: FC<InlineQuantityControlFieldProps> = props => {
//   const { fullWidth, input } = props;
//   return (
//       <InlineQuantityControl
//           fullWidth={fullWidth}
//           {...input}/>
//   )
// };
